import { createFileRoute } from '@tanstack/react-router'
import TransactionCategories from '@/features/transaction-categories'

export const Route = createFileRoute('/_authenticated/transaction-category/')({
  component: TransactionCategories,
})
